import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { TabsetConfig } from 'ngx-bootstrap/tabs';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogType, Personality } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { Customer } from 'src/app/models/customer';
import { OnbaseCatalogue } from 'src/app/models/onbase-catalogue';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';


export function getTabsetConfig(): TabsetConfig {
  return Object.assign(new TabsetConfig(), { type: 'pills', isKeysAllowed: true });
}
@Component({
  selector: 'app-credit-request-save-step',
  templateUrl: './credit-request-save-step.component.html',
  styleUrls: ['./credit-request-save-step.component.sass'],
  // providers: [{ provide: TabsetConfig, useFactory: getTabsetConfig }]
})
export class CreditRequestSaveStepComponent implements OnInit {

  constructor(private confirmService: PosConfirmationService, private toastr: ToastrService, private configService: ConfigurationService, private readonly exceptionSolutionService: ExceptionSolutionService) { }

  @Input() forms: Map<string, AbstractControl> = new Map();
  @Input() customerType: string = "PERSON";
  @Input() onbaseCatalogue: OnbaseCatalogue = new OnbaseCatalogue();
  @Input() disable: boolean = true;
  @Input() customer: Customer = new Customer();
  @Input() hideStreet: boolean = false;
  @Input() listOfBranchesNotValidateBiometry = "";
  @Output() reconfigureForms = new EventEmitter<any>()
  @Output() createRequest = new EventEmitter<boolean>();
  @Output() gotoStep = new EventEmitter<string>();
  private _resetInput: number = 0;
  @Input()
  get resetInput(): number {
    return this._resetInput;
  }

  set resetInput(value: number) {
    this.updateValidationForm();
    this._resetInput = value;
  }

  @Input() creditRequestNumber: string = "";
  @Input() requestType: `AVAL` | `CUSTOMER` | string = "";
  @Input() pictureUrlString: string = "";
  @Input() documentsForm: FormArray = new FormArray([]);
  @Input() isShortFormActiveForPlan = false;
  formsToShowConfig: any = {
    generalnformationForm: false,
    bankRepresentativeForm: false,
    companyInformationForm: false,
    companyAddressInformationForm: false,
    companyContactInformationForm: false,
    companyBankingReferenceForm: false,
    personInformationForm: false,
    personAddressInformationForm: false,
    personIncomeInformationForm: false,
    personReferencesInformationform: false,
    observationForm: false,
    documentsForm: false,
  };

  formsValid: any = {
    generalnformationForm: true,
    bankRepresentativeForm: true,
    companyInformationForm: true,
    companyAddressInformationForm: true,
    companyContactInformationForm: true,
    companyBankingReferenceForm: true,
    personInformationForm: true,
    personAddressInformationForm: true,
    personIncomeInformationForm: true,
    personReferencesInformationform: true,
    observationForm: true,
    documentsForm: true,
  }

  ngOnInit(): void {
    this.resetConfig();
    this.forms.forEach((x, y, i) => {
      this.formsToShowConfig[y] = true;
    });
  }

  resetConfig() {
    this.formsToShowConfig = {
      generalnformationForm: false,
      bankRepresentativeForm: false,
      companyInformationForm: false,
      companyAddressInformationForm: false,
      companyContactInformationForm: false,
      companyBankingReferenceForm: false,
      personInformationForm: false,
      personAddressInformationForm: false,
      personIncomeInformationForm: false,
      personReferencesInformationform: false,
      observationForm: false,
      documentsForm: false,
    };
  }

  getFormAsFormGroup(key: string) {
    let form = this.forms.get(key)! as FormGroup;
    return form;
  }

  getFormAsFormArray(key: string) {

    let form = this.forms.get(key)! as FormArray;
    return form;
  }

  public async save() {
    const result = await this.confirmService.showAsync("Creación de Solicitud", "¿Esta seguro de crear la solicitud?", ModalDialogType.SUCCESS);

    if (result) {

      this.reconfigureForms.emit();
      let formsToValidate = Array.from(this.forms.values()).map(f => {
        return f;
      });
      this.updateValidationForm();
      if (formsToValidate.every(x => x.valid)) {
        await this.createRequest.emit(false);
      }
      else {
        this.exceptionSolutionService.showAlertWithSolution(`Solicitud de Créditos`, `No se puede crear la solicitud ya que hace falta campos obligatorios que llenar`);
      }

    }
  }

  async draft() {
    const result = await this.confirmService.showAsync("Creación de Solicitud en Borradores", "¿Esta seguro de crear la solicitud en Borradores?", ModalDialogType.PRIMARY);

    if (result) {
      await this.createRequest.emit(true);
    }
  }

  getClassFromForm(form: string) {

    let result = this.formsValid[form];

    return result ? 'nav-valid' : 'nav-invalid';

  }

  updateValidationForm() {
    this.forms.forEach((x, y, i) => {
      this.formsValid[y] = x.valid;
    })
  }

  goToCompleteStep(step: string) {
    this.gotoStep.emit(step);
  }

  canShowSaveButton(): boolean {
    return this.listOfBranchesNotValidateBiometry.includes(this.configService.readSelectedBranchAndSalesOrg().branch.code)
      || this.customer.mainPersonalInfo.personality === Personality.LEGAL_ENTITY
      || this.customerType === 'EMPLOYEE'
      || this.requestType === 'AVAL'
      || this.customerType == "FRANCHISED" || this.isShortFormActiveForPlan;
  }

  canShowSaveButtonForAlert(): boolean {
    return this.listOfBranchesNotValidateBiometry.includes(this.configService.readSelectedBranchAndSalesOrg().branch.code)
      || this.customer.mainPersonalInfo.personality === Personality.LEGAL_ENTITY
      || this.customerType === 'EMPLOYEE';
  }

  handleGoToBiometryValidationClick(): void {
    this.reconfigureForms.emit();
    let formsToValidate = Array.from(this.forms.values()).map(f => {
      return f;
    });

    console.log(`documents form`, this.documentsForm.value);

    this.updateValidationForm();
    if (formsToValidate.some(x => !x.valid)) {
      this.exceptionSolutionService.showAlertWithSolution(`Solicitudes de Crédito`, `Debes de completar los datos de solicitud antes de realizar validacion biometrica.`);
    } else if (this.creditRequestNumber == "") {
      this.exceptionSolutionService.showAlertWithSolution(`Solicitudes de Crédito`, `Debes de guardar en borradores la solicitud antes de realizar validacion biometrica.`);
    } else if (this.pictureUrlString === "" && this.documentsForm.value.find((d: any) => d.description === 'Segunda Identificación') != undefined && this.requestType !== 'AVAL') {
      this.exceptionSolutionService.showAlertWithSolution(`Solicitudes de Crédito`, `Debes de tomar 'fotografía "in situ"' antes de realizar validacion biometrica.`);
    } else {
      this.goToCompleteStep('biometryValidationForm');
    }
  }
}
